var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6719 0.5H2.33854C1.42187 0.5 0.671875 1.25 0.671875 2.16667V13.8333C0.671875 14.75 1.42187 15.5 2.33854 15.5H15.6719C16.5885 15.5 17.3385 14.75 17.3385 13.8333V2.16667C17.3385 1.25 16.5885 0.5 15.6719 0.5ZM15.6719 13.8333H2.33854V2.16667H15.6719V13.8333Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1828 6.68333L13.9995 5.5L11.3578 8.14167L10.1828 6.95833L9.00781 8.13333L11.3578 10.5L15.1828 6.68333Z",
    fill: "#475467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33854 3.83325H3.17188V5.49992H7.33854V3.83325Z",
    fill: "#475467"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33854 7.16675H3.17188V8.83341H7.33854V7.16675Z",
    fill: "#475467"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33854 10.5H3.17188V12.1667H7.33854V10.5Z",
    fill: "#475467"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeen);
export default __webpack_public_path__ + "static/media/seen.ef2ae3b93b164aa77b9371601070c21d.svg";
export { ForwardRef as ReactComponent };